import { render, staticRenderFns } from "./Travelarrangements.vue?vue&type=template&id=2ce6b6df"
var script = {}
import style0 from "./Travelarrangements.vue?vue&type=style&index=0&id=2ce6b6df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports